import { useCallback, useRef } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { PATHS } from '@/common';

interface Response {
  upload_url?: string
  file_name?: string
  object_key?: string;
}

interface Payload {
  documentId: string;
  qrId?: string;
  name?: string;
  employeeId?: string;
}

const useCreateFileUploadUrlByQrCodeQuery = () => {
  const controllerRef = useRef(new AbortController());

  const { mutateAsync, isLoading } = useMutation(
    (payload: Payload) => {
      controllerRef.current = new AbortController();
      return api.post<Response>(PATHS.CREATE_FILE_UPLOAD_URL_BY_QR_CODE(payload?.documentId), {
        qr_id: payload?.qrId,
        name: payload?.name,
        employee_id: payload?.employeeId,
      }, {
        signal: controllerRef.current.signal,
      });
    }
  );

  const cancelCreateFileUploadUrl = useCallback(() => {
    controllerRef.current.abort();
  }, []);

  return {
    createFileUploadUrlByQrCode: mutateAsync,
    cancelCreateFileUploadUrl,
    isLoading,
  };
};

export default useCreateFileUploadUrlByQrCodeQuery;
